import { FoldHorizontal, UnfoldHorizontal } from 'lucide-react'
import { usePageWidth } from './pageWidth.js'

/**
 * The shells' full-width control (the user's call, 27 October 2026: an icon alone, subtle, at the right end of the
 * section bar after its last item): unfold arrows while the pages sit in their column, fold arrows once they draw as
 * wide as the window. Named for screen readers and on hover; the choice is this browser's (`usePageWidth`). `tone`
 * is where it sits: the white bar by default, or the dark header in the sign-out icon's style.
 */
export function PageWidthButton({ tone = 'bar' }: { tone?: 'bar' | 'header' }) {
  const { full, setFull } = usePageWidth()
  const label = full ? 'Draw the pages in a column' : 'Draw the pages full width'
  const colours = tone === 'header' ? 'text-white/60 hover:bg-white/10 hover:text-white' : 'self-center text-ink-mid/70 hover:bg-marine/10 hover:text-marine'
  return (
    <button
      type="button"
      onClick={() => setFull(!full)}
      aria-label={label}
      aria-pressed={full}
      title={label}
      className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-coral ${colours}`}
    >
      {full ? <FoldHorizontal aria-hidden="true" className="h-4 w-4" /> : <UnfoldHorizontal aria-hidden="true" className="h-4 w-4" />}
    </button>
  )
}
